import { InjectionToken } from '@angular/core';

export interface CountDownConfigurationToken {
  pingInterval: number;
  idleInterval: number;
  timeoutInterval: number;
}

export const COUNTDOWN_CONFIGURATION_TOKEN = new InjectionToken<
  CountDownConfigurationToken
>('Configure countdown configuration token');
